import { AsciiText } from '../framework/AsciiText';
export class WolfVisionCynap {
    constructor(socket, log) {
        this.socket = socket;
        this.firmwareVersion = '{"cynap":{"version":"V1.54e","buildnumber":"20220628031909","stage":"release"}}';
        this.input1Name = 'HDMI1';
        this.input2Name = 'HDMI2';
        this.mediaRecording = false;
        this.mediaStreaming = false;
        this.mute = false;
        this.power = true;
        this.recordingStartTime = 0;
        this.urlDialed = '';
        this.videoInput = 0x00; // home screen
        this.volume = 50; // Main volume
        this.volumeMute = false;
        this.asyncHandlers = [
            {
                name: 'firmwareVersion',
                regExp: /\x08\xCB\x50\x00/,
                callback: (match) => {
                    if (!this.power) {
                        this.socket.send(this.makeCommand([0x88, 0xcb, 0x50, 0x00]));
                    }
                    else {
                        const length = this.firmwareVersion.length;
                        this.socket.send(this.makeCommand([
                            0x0c,
                            0xcb,
                            0x50,
                            (length & 0xff00) >> 8,
                            length & 0x00ff,
                            ...AsciiText.encode(this.firmwareVersion),
                        ]));
                    }
                },
            },
            {
                name: 'closeWindow',
                regExp: /\x09\xcb\x28\x02([\s\S]{2})/,
                callback: (match) => {
                    if (!this.power) {
                        this.socket.send(this.makeCommand([0x89, 0xcb, 0x28, 0x07]));
                    }
                    else {
                        this.videoInput = 0x00; // Reset to the home screen
                        this.urlDialed = '';
                        this.socket.send(this.makeCommand([0x09, 0xcb, 0x28, 0x00]));
                    }
                },
            },
            {
                name: 'login',
                regExp: /\x09\xcb\x42[\s\S]{3}([\s\S]+)/,
                callback: (match) => {
                    if (!this.power) {
                        this.socket.send(this.makeCommand([0x89, 0xcb, 0x42, 0x07]));
                    }
                    else {
                        // successful login
                        this.socket.send(this.makeCommand([0x09, 0xcb, 0x42, 0x00]));
                    }
                },
            },
            {
                name: 'loginLevel',
                regExp: /\x08\xcb\x55\x00/,
                callback: (match) => {
                    if (!this.power) {
                        this.socket.send(this.makeCommand([0x89, 0xcb, 0x55, 0x07]));
                    }
                    else {
                        // Respond logged in as admin
                        this.socket.send(this.makeCommand([0x08, 0xcb, 0x55, 0x01, 0x02]));
                    }
                },
            },
            {
                name: 'muteQuery',
                regExp: /\x08\xCB\x59\x00/,
                callback: (match) => {
                    if (!this.power) {
                        this.socket.send(this.makeCommand([0x88, 0xcb, 0x59, 0x00]));
                    }
                    else {
                        this.socket.send(this.makeCommand([0x08, 0xcb, 0x59, 0x01, this.mute ? 1 : 0]));
                    }
                },
            },
            {
                name: 'muteSet',
                regExp: /\x09\xCB\x59\x01([\s\S])/,
                callback: (match) => {
                    if (!this.power) {
                        this.socket.send(this.makeCommand([0x89, 0xcb, 0x59, 0x00]));
                    }
                    else {
                        this.mute = match[1] === '\x01';
                        this.socket.send(this.makeCommand([0x09, 0xcb, 0x59, 0x00]));
                    }
                },
            },
            {
                name: 'powerQuery',
                regExp: /\x08\xCB\x0C\x00/,
                callback: (match) => {
                    this.socket.send(this.makeCommand([0x08, 0xcb, 0x0c, 0x01, this.power ? 1 : 0]));
                },
            },
            {
                name: 'powerSet',
                regExp: /\x09\xCB\x0C\x01([\s\S])/,
                callback: (match) => {
                    this.power = match[1] === '\x01';
                    this.socket.send(this.makeCommand([0x09, 0xcb, 0x0c, 0x00]));
                },
            },
            {
                name: 'presentationEnd',
                regExp: /\x09\xCB\x49\x03\x00\x00\x00/,
                callback: (match) => {
                    if (!this.power) {
                        this.socket.send(this.makeCommand([0x89, 0xcb, 0x49, 0x00]));
                    }
                    else {
                        this.videoInput = 0x00; // Reset to the home screen
                        this.urlDialed = '';
                        this.socket.send(this.makeCommand([0x09, 0xcb, 0x49, 0x00]));
                    }
                },
            },
            {
                name: 'routeQuery',
                regExp: /\x08\xcd\x42\x00/,
                callback: (match) => {
                    if (!this.power) {
                        // Error response
                        this.socket.send(this.makeCommand([0x88, 0xcd, 0x42, 0x00]));
                    }
                    else {
                        const header = [0x0c, 0xcd, 0x42];
                        const windowSize = [
                            0x0f,
                            0x00,
                            0x08,
                            0x70, // window height 2
                        ];
                        const emptyWin = [0x10, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
                        let window0 = [];
                        if ([1, 2, 80].includes(this.videoInput)) {
                            // HDMI 1 or 2
                            window0 = this.makeHdmiResponse(this.videoInput);
                        }
                        else if (this.videoInput === 27) {
                            // Microsoft Teams source selection.
                            let teamsUrl = 'https://teams.microsoft.com/_#/conversations/General?threadId=19:162867a6221f445fae83a1a5bcb930c8@thread.tacv2&ctx=channel.General (Acme Inc.) | Microsoft Teams';
                            if (this.urlDialed !== '') {
                                // Return a valid meeting join response.
                                teamsUrl =
                                    'https://teams.microsoft.com/_#/pre-join-calling/19:meeting_NzkfM2QyZjItOWFmNy00MzNlLWJmZDYtMTVhN2U3ZTUzMTRj@thread.v';
                            }
                            window0 = this.makeBrowserResponse(this.videoInput, teamsUrl);
                        }
                        else if (this.videoInput === 15 || this.videoInput === 29) {
                            // Zoom call
                            window0 = this.makeZoomResponse(this.videoInput);
                        }
                        else if ([3, 19, 20, 21, 22, 23, 26].includes(this.videoInput)) {
                            window0 = this.makeBrowserResponse(this.videoInput, 'google.com');
                        }
                        else {
                            window0 = this.makeHdmiResponse(this.videoInput);
                        }
                        const length = windowSize.length + window0.length + 3 * emptyWin.length;
                        this.socket.send(this.makeCommand([
                            ...header,
                            ...this.byteLen(length),
                            ...windowSize,
                            // We are only controlling the first window
                            ...window0,
                            // 3 empty windows
                            ...emptyWin,
                            ...emptyWin,
                            ...emptyWin,
                        ]));
                    }
                },
            },
            {
                name: 'routeSet',
                regExp: /\x0b\x01\xcd\x28[\x00]{3}[\s\S]\x00([\s\S])[\s\S]{2}([\s\S]+)/,
                callback: (match) => {
                    if (!this.power) {
                        // Error response
                        this.socket.send(this.makeCommand([0x89, 0xcd, 0x28, 0x00]));
                    }
                    else {
                        this.videoInput = match[1].charCodeAt(0);
                        // Check the index value for the HDMI input
                        if (match[1] === '\x02' && match[2].charCodeAt(0) === 1)
                            this.videoInput = 80; // HDMI 2
                        if (match[1] === '\x1b' || match[1] === '\x0f' || match[1] === '\x1d') {
                            // Valid http style dial string for dialing zoom  or teams
                            const url = match[2];
                            if (url.match(/us02web\.zoom\.us\/.+\/\d+/i) ||
                                url.match(/zoom.us\/..\/(?:join\/)?(\d+)/i) ||
                                url.match(/zoom\.us\/wc\/.+\/join\?track_id/i) ||
                                url.match(/teams\.microsoft\.com\/_#\/pre-join-calling/i) ||
                                url.match(/teams\.microsoft\.com\/.\/meetup-join/i) ||
                                url.match(/teams\.microsoft\.com\/_#\/modern-calling/i)) {
                                this.urlDialed = url;
                            }
                        }
                        this.socket.send(this.makeCommand([0x09, 0xcd, 0x28, 0x00]));
                    }
                },
            },
            {
                name: 'streamingQuery',
                regExp: /\x08\xCB\x20\x00/,
                callback: (match) => {
                    if (!this.power) {
                        this.socket.send(this.makeCommand([0x88, 0xcb, 0x20, 0x00]));
                    }
                    else {
                        this.socket.send(this.makeCommand([
                            0x08,
                            0xcb,
                            0x20,
                            0x01,
                            this.mediaStreaming ? 0x01 : 0x00,
                        ]));
                    }
                },
            },
            {
                name: 'streamingSet',
                regExp: /\x09\xCB\x20\x01([\s\S])/,
                callback: (match) => {
                    if (!this.power) {
                        this.socket.send(this.makeCommand([0x89, 0xcb, 0x20, 0x00]));
                    }
                    else {
                        this.mediaStreaming = match[1] === '\x01'; // '\x00' = off
                        this.socket.send(this.makeCommand([0x09, 0xcb, 0x20, 0x00]));
                    }
                },
            },
            {
                name: 'systemReboot',
                regExp: /\x09\xCC\xF5\x01([\s\s])/,
                callback: (match) => {
                    if (!this.power) {
                        this.socket.send(this.makeCommand([0x89, 0xcc, 0xf5, 0x00]));
                    }
                    else {
                        this.socket.send(this.makeCommand([0x09, 0xcc, 0xf5, 0x00]));
                    }
                },
            },
            {
                name: 'videoRecordingQuery',
                regExp: /\x08\xCB\x25\x00/,
                callback: (match) => {
                    if (!this.power) {
                        this.socket.send(this.makeCommand([0x88, 0xcb, 0x25, 0x00]));
                    }
                    else {
                        const recordingTime = this.recordingStartTime > 0
                            ? this.byteLen(Date.now() - this.recordingStartTime, 4)
                            : [0, 0, 0, 0];
                        this.socket.send(this.makeCommand([
                            0x08,
                            0xcb,
                            0x25,
                            0x05,
                            this.mediaRecording ? 0x00 : 0x02,
                            ...recordingTime,
                        ]));
                    }
                },
            },
            {
                name: 'videoRecordingSet',
                regExp: /\x09\xCB\x25\x01([\s\S])/,
                callback: (match) => {
                    if (!this.power) {
                        this.socket.send(this.makeCommand([0x89, 0xcb, 0x25, 0x00]));
                    }
                    else {
                        this.mediaRecording = match[1] === '\x00'; // '\x01' = pause/resume, '\x02' = stop
                        if (this.mediaRecording) {
                            this.recordingStartTime = Date.now();
                        }
                        this.socket.send(this.makeCommand([0x09, 0xcb, 0x25, 0x00]));
                    }
                },
            },
            {
                name: 'volumeQuery',
                regExp: /\x08\xCB\x56\x00/,
                callback: (match) => {
                    if (!this.power) {
                        this.socket.send(this.makeCommand([0x88, 0xcb, 0x56, 0x00]));
                    }
                    else {
                        this.socket.send(this.makeCommand([0x08, 0xcb, 0x56, 0x01, this.volume]));
                    }
                },
            },
            {
                name: 'volumeSet',
                regExp: /\x09\xCB\x56\x01([\s\S])/,
                callback: (match) => {
                    if (!this.power) {
                        this.socket.send(this.makeCommand([0x89, 0xcb, 0x56, 0x00]));
                    }
                    else {
                        this.volume = match[1].charCodeAt(0);
                        this.socket.send(this.makeCommand([0x09, 0xcb, 0x56, 0x00]));
                    }
                },
            },
            {
                name: 'volumeMuteQuery',
                regExp: /\x08\xCB\x58\x00/,
                callback: (match) => {
                    if (!this.power) {
                        this.socket.send(this.makeCommand([0x88, 0xcb, 0x58, 0x00]));
                    }
                    else {
                        this.socket.send(this.makeCommand([0x08, 0xcb, 0x58, 0x01, this.volumeMute ? 1 : 0]));
                    }
                },
            },
            {
                name: 'volumeMuteSet',
                regExp: /\x09\xCB\x58\x01([\s\S])/,
                callback: (match) => {
                    if (!this.power) {
                        this.socket.send(this.makeCommand([0x89, 0xcb, 0x58, 0x00]));
                    }
                    else {
                        this.volumeMute = match[1] === '\x01';
                        this.socket.send(this.makeCommand([0x09, 0xcb, 0x58, 0x00]));
                    }
                },
            },
        ];
    }
    // Returns array of numBytes length of the src number, high byte first
    byteLen(src, numBytes = 2) {
        const result = [];
        for (let i = numBytes - 1; i >= 0; i--) {
            result.push((src & (0x000000ff << (i << 3))) >> (i << 3));
        }
        return result;
    }
    makeCommand(data) {
        return AsciiText.decode(data);
    }
    makeBrowserResponse(src, url) {
        const urLen = this.byteLen(url.length);
        const lb0_1 = this.byteLen(url.length + 2);
        const window = [
            0x10,
            src,
            0x01,
            //
            0x00,
            0x00,
            0x00,
            0x00,
            //
            0x0f,
            0x00,
            0x08,
            0x70,
            //
            this.mute ? 1 : 0,
            this.volume,
            //
            0x00,
            0x00,
            0x00,
            0x00,
            // specific block length
            // lb0...lb1
            ...lb0_1,
            ...urLen,
            ...AsciiText.encode(url),
            // title length
            0,
            0,
            //t0..tn title
            //it input type
            // pdf: pdf viewer active
            //pp0..pp3: page of pdf
            // tpp0...tpp3: total page count of pdf
            //bu: busy
            //pft0..pft3: password field top: 00 00 00 00
        ];
        return window;
    }
    makeZoomResponse(src) {
        const regExp = /(.+)\.zoom\.us\/j\/(\d+).+/i;
        if (this.urlDialed !== '') {
            const match = regExp.exec(this.urlDialed);
            if (match) {
                const returnUrl = `https://${match[1]}.zoom.us/wc/${match[2]}/join?track_id=&jmf_code=&meeting_result=&tk=&cap=undefined&refTK=&rn=false&po=7&epk=-rL_l4-o3uOo-v2hqj7NmGCRDBOny3yCuM9r_fwoBrnT_E2gd80.CF51-LW5N6FwOC8c&wpk=wcpk89a1765a446b6641dd71bdecddafd97`;
                // Dialed a call
                return this.makeBrowserResponse(src, returnUrl);
            }
        }
        return this.makeBrowserResponse(src, 'https://zoom.us');
    }
    makeHdmiResponse(src) {
        const hdmiName = src === 2 ? this.input1Name : this.input2Name;
        const hdmiWindow = [
            0x10,
            src === 80 ? 2 : src,
            0x01,
            //
            0x00,
            0x00,
            0x00,
            0x00,
            //
            0x0f,
            0x00,
            0x08,
            0x70,
            //
            this.mute ? 1 : 0,
            this.volume,
            //
            0x00,
            0x00,
            0x00,
            0x00,
            // specific block length
            ...this.byteLen(hdmiName.length + 6),
            //
            // for Visualizer & HDMI (window types 1 and 2)
            //
            0x00,
            0x00,
            0x00,
            src === 80 ? 1 : 0,
            //
            ...this.byteLen(hdmiName.length),
            ...AsciiText.encode(hdmiName),
        ];
        return hdmiWindow;
    }
}
WolfVisionCynap.emulatorType = 'socketEmulator';
WolfVisionCynap.key = '-NBlvFUC6ts4r-VGpDuo';
